import { use } from 'react';
import I18nContext from '../i18n.context';
const useCurrency = () => {
    const { currency } = use(I18nContext);
    return currency;
};
export default useCurrency;
